import axios from 'axios';

const API_BASE_URL = '/api/content';

export const contentApi = {
  getUserContext: async () => {
    const response = await axios.get(`${API_BASE_URL}/context`);
    return response.data;
  },
  getProducts: async (lang?: string, isPublic?: boolean) => {
    const response = await axios.get(`${API_BASE_URL}/products`, {
      params: { lang, public: isPublic }
    });
    return response.data;
  },
  
  getProduct: async (productId: string, lang?: string) => {
    const response = await axios.get(`${API_BASE_URL}/products/${productId}`, {
      params: { lang }
    });
    return response.data;
  },
  
  getProfiles: async (lang?: string) => {
    const response = await axios.get(`${API_BASE_URL}/profiles`, {
      params: { lang }
    });
    return response.data;
  },
  
  getProfile: async (userId: string, lang?: string) => {
    const response = await axios.get(`${API_BASE_URL}/profiles/${userId}`, {
      params: { lang }
    });
    return response.data;
  },

  getJobs: async (lang?: string) => {
    const response = await axios.get(`${API_BASE_URL}/jobs`, {
      params: { lang }
    });
    return response.data;
  },

  saveProduct: async (product: any) => {
    const response = await axios.post(`${API_BASE_URL}/products`, product);
    return response.data;
  },

  saveJob: async (job: any) => {
    const response = await axios.post(`${API_BASE_URL}/jobs`, job);
    return response.data;
  },

  saveProfile: async (profile: any) => {
    const response = await axios.post(`${API_BASE_URL}/profiles`, profile);
    return response.data;
  },

  triggerTranslation: async (id: string, type: 'product' | 'profile' | 'job', data: any, fields: string[], sourceLanguage: string = 'es') => {
    try {
      const response = await axios.post(`${API_BASE_URL}/translate/${type}/${id}`, {
        data,
        fields,
        sourceLanguage
      });
      return response.data;
    } catch (error) {
      console.warn('Translation trigger failed (this is expected if API is not configured):', error);
      return null;
    }
  },

  fixTestProducts: async () => {
    console.log('API: Calling fixTestProducts...');
    const response = await axios.post(`${API_BASE_URL}/fix-test-products`);
    console.log('API: fixTestProducts response:', response.data);
    return response.data;
  },

  retranslateProducts: async () => {
    const response = await axios.post(`${API_BASE_URL}/retranslate-products`);
    return response.data;
  },

  migrate: async () => {
    const response = await axios.post(`${API_BASE_URL}/migrate`);
    return response.data;
  },
  
  getSettings: async (type: string) => {
    const response = await axios.get(`${API_BASE_URL}/settings/${type}`);
    return response.data;
  },
  
  saveSettings: async (type: string, settings: any) => {
    const response = await axios.post(`${API_BASE_URL}/settings/${type}`, settings);
    return response.data;
  }
};
